import type React from 'react';
import {
  designTokens,
  Flex,
  Label,
  type DeepReadonly
} from '@itandi/itandi-bb-ui';
import Styles from './ChatDealListPane.module.scss';
import { ChatDealListRowsClient } from './ChatDealListRowsClient';
import { ChatDealListRowsVendor } from './ChatDealListRowsVendor';
import type { ItandiAccount } from '~/models/ItandiAccount';

type Props = DeepReadonly<{
  isVendor: boolean;
  store: ItandiAccount['store'];
}>;

export const ChatDealListPane: React.FC<Props> = ({
  isVendor,
  store
}: Props) => (
  <div className={Styles.ChatDealListPane}>
    <Flex
      alignItems="center"
      gap={designTokens['spacing/m']}
      mb={designTokens['spacing/m']}
    >
      <h1 className={Styles.Title}>
        {isVendor ? '管理会社とのチャット' : '施工会社とのチャット'}
      </h1>
      {store?.masterAccount && (
        <Label color="subtle" size="s">
          {`本画面では所属店舗（${store.name}）のチャットのみ表示されます。`}
        </Label>
      )}
    </Flex>
    <div>
      {isVendor ? <ChatDealListRowsVendor /> : <ChatDealListRowsClient />}
    </div>
  </div>
);
